import FaithEmbed from "./images/FaithEmbed";

const PodcastList = {
        tabHeading: 'Podcasts - Playlist and Player',
        metaDescription: `Audio Player with a list of the most recent episodes of the True Liberty North Podcast.`,
        keywords: ["TrueLibertyNorth", "TrueLibertyNorth Podcast", "True Liberty North Podcast"],
        firstName: '',
        title: 'Most Recent',
        id: '0001 Truth Liberty',
        from: 'Now Playing ------ ',
        image: FaithEmbed,
        headTitle: ``,
        headDescription: `True Liberty North Podcasts with a built in player as well as links to where you can find them for download.`,
        content: [
            {
            title: `#1 - Truth and Liberty`,
            id: '0001 Truth Liberty',
            date: 'Jul. 29 / 2025',
            description: `What is Truth and what is Liberty? What do they mean if we continue to fall away from God? These ideas go much deeper than, I think, many of us 
            realize, to the point of taking them for granted.`
            },
            {
            title: '#2 - Mission (Turning Back to God)',
            id: '0002 Mission',
            date: 'Sept. 12 / 2025',
            description: `The only answer; Turn Back to God. Pray, “Lord, Save Me”. Turn back to the Scripture for truth and understanding. Renew your relationship with God 
            through Christ. The only way to cope with the craziness is to develop a strong Faith and then hold to it.`
            },
            {
            title: '#3 - Putting God First',
            id: '0003 God First',
            date: 'Mar. 27 / 2026',
            description: `What does it really mean to put God First? To say we are Jewish or Christian or to say 'Jesus is Lord' has to be more than just saying the words. 
            How much do we believe what the Bible teaches and are we truly living the way we are called to as 'believers', aka children of God?`
            },
            {
            title: 'Coming Soon!',
            id: '0000 Coming Soon',
            date: 'Coming Soon',
            description: `True Liberty North is currently working hard on a brand new episode. Just hang in there because the next one is coming very soon. I promise. 
            Trust me, it'll be worth the wait, so keep checking back.`
            },
            {
            title: 'Coming Soon!',
            id: '0000 Coming Soon',
            date: 'Coming Soon',
            description: `True Liberty North is currently working hard on a brand new episode. Just hang in there because the next one is coming very soon. I promise. 
            Trust me, it'll be worth the wait, so keep checking back.`
            },
            {
            title: 'Coming Soon!',
            id: '0000 Coming Soon',
            date: 'Coming Soon',
            description: `True Liberty North is currently working hard on a brand new episode. Just hang in there because the next one is coming very soon. I promise. 
            Trust me, it'll be worth the wait, so keep checking back.`
            },
            {
            title: 'Coming Soon!',
            id: '0000 Coming Soon',
            date: 'Coming Soon',
            description: `True Liberty North is currently working hard on a brand new episode. Just hang in there because the next one is coming very soon. I promise. 
            Trust me, it'll be worth the wait, so keep checking back.`
            },
            {
            title: 'Coming Soon!',
            id: '0000 Coming Soon',
            date: 'Coming Soon',
            description: `True Liberty North is currently working hard on a brand new episode. Just hang in there because the next one is coming very soon. I promise. 
            Trust me, it'll be worth the wait, so keep checking back.`
            },
            {
            title: 'Coming Soon!',
            id: '0000 Coming Soon',
            date: 'Coming Soon',
            description: `True Liberty North is currently working hard on a brand new episode. Just hang in there because the next one is coming very soon. I promise. 
            Trust me, it'll be worth the wait, so keep checking back.`
            },
            {
            title: 'Coming Soon!',
            id: '0000 Coming Soon',
            date: 'Coming Soon',
            description: `True Liberty North is currently working hard on a brand new episode. Just hang in there because the next one is coming very soon. I promise. 
            Trust me, it'll be worth the wait, so keep checking back.`
            },
            {
            title: 'Coming Soon!',
            id: '0000 Coming Soon',
            date: 'Coming Soon',
            description: `True Liberty North is currently working hard on a brand new episode. Just hang in there because the next one is coming very soon. I promise. 
            Trust me, it'll be worth the wait, so keep checking back.`
            }   
        ],
        quotes: [
            {
        considerations: [
            {
                name: '',
                title: 'James 1:19,20',
                date: '',
                content: [`My dear brothers and sisters, take note of this: Everyone should be quick to listen, slow to speak and slow to become angry, because human 
                anger does not produce the righteousness that God desires.`]
            },
            {
                name: '',
                title: '2nd Thessalonians 3:7-10',
                date: '',
                content: [`We were not idle when we were with you, nor did we eat anyone's food without paying for it. On the contrary, we worked night and day, 
                laboring and toiling so that we would not be a burden to any of you. We did this, not because we do not have the right to such help, but in order 
                to offer ourselves as a model for you to imitate. For even when we were with you, we gave you this rule: 'The one who is unwilling to work shall 
                not eat.'`]
            },
            {
                name: '',
                title: 'Adam Smith',
                date: '1776',
                content: [`It is not from the benevolence of the butcher, the brewer, or the baker that we expect our dinner, but from their regard to their own 
                interest. We address ourselves, not to their humanity but to their self-love, and never talk to them of our own necessities but of their advantages.`,
                `Nobody but a beggar chooses to depend chiefly upon the benevolence of his fellow-citizens. Even a beggar does not depend upon it entirely. The 
                charity of well-disposed people, indeed, supplies him with the whole fund of his subsistence...The greater part of his occasional wants are supplied 
                in the same manner as those of other people, by treaty, by barter, and by purchase. With the money which one man gives him he purchases food. The old 
                clothes which another bestows upon him he exchanges for other old clothes which suit him better, or for lodging, or for food, or for money, with which 
                he can buy either food, clothes, or lodging, as he has occasion.`]
            }
        ]
    }]
    };

export default PodcastList;